import { useToaster, useTableSeeker } from 'ui-seeker/core'
import { getSubmit, postSubmit } from 'ui-seeker/utils'

import { ALERTS } from 'app/@common/constants'


export default function useRemoveAlertsItems() {

    const { showToaster } = useToaster()
    const { setTableData, setLoadingTable } = useTableSeeker()

    const getStringAlert = tp => {
        if ([5,6].find(e => e === tp)) return 'competition'
        if ([1,3].find(e => e === tp)) return 'parity-meta'
        if ([2,4].find(e => e === tp)) return 'parity-ota'
        if ([7,8].find(e => e === tp)) return 'packages'
        if ([9].find(e => e === tp)) return 'info'
    }

    const onGetAlerts = alertType => {
        setLoadingTable(true)
        getSubmit(`${ALERTS.LIST}/${getStringAlert(alertType)}`).then(data => {
            setTableData(data)
        }).catch(() => {
            showToaster.error()
            setLoadingTable(false)
        })
    }

    const removeAlerts = (data, alertType) => {
        showToaster.loading()
        postSubmit(ALERTS.DELETE, { alertID: data }).then(() => {
            onGetAlerts(alertType)
            showToaster.success(`Alert(s) removed`)
        }).catch(() => {
            showToaster.error()
        })
    }

	return {
		removeAlerts
	}
}